import { render, staticRenderFns } from "./BarraDireito.vue?vue&type=template&id=6a99c1e7&scoped=true"
import script from "./BarraDireito.vue?vue&type=script&lang=js"
export * from "./BarraDireito.vue?vue&type=script&lang=js"
import style0 from "./BarraDireito.vue?vue&type=style&index=0&id=6a99c1e7&prod&lang=css"
import style1 from "./BarraDireito.vue?vue&type=style&index=1&id=6a99c1e7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a99c1e7",
  null
  
)

export default component.exports